export const DOCUMENT_UPLOAD_TEMPLATE_SLICE = 'DOCUMENT_UPLOAD_TEMPLATE_SLICE';
